const t = {
  backgroundContainerColor: "#FFFFFF",
  backgroundContainerOpacity: 100,
  backgroundCornerRadius: 8,
  textFontFamily: "Open Sans",
  textFontWeight: 700,
  textFontSize: 13,
  textFontColor: "#333333",
  textFontOpacity: 100,
  leaderLineVisible: !0
}, e = {
  poiId: ""
}, o = {
  text: "",
  textOptionsEnabled: !0,
  textboxStyleConfig: t,
  offsetMap: {},
  geolocation: {
    lng: 0,
    lat: 0
  }
};
export {
  e as TextboxDefaultFetchFilter,
  o as TextboxDefaultVisualFilter,
  t as defaultTextboxConfig
};
//# sourceMappingURL=index.es101.js.map
